import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { tokenStore } from "@/lib/native";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        await tokenStore.load();
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) await tokenStore.set(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) await tokenStore.set(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { const { revokeThisDevice } = await import("@/lib/push"); await revokeThisDevice(); } catch {}
    try { await api.post("/auth/logout"); } catch {}
    await tokenStore.remove();
    setUser(null);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
